export default __webpack_public_path__ + "static/media/placeholder-firstServe-thumbnail.e857dc67.svg";